import * as React from 'react';
import styles from './index.less';
import img_markdown from '@/assets/cartoon-editor-icons.png';
import FComponentsLib from '@freelog/components-lib';
import { FI18n } from '@freelog/tools-lib';

interface FResourceCartoonEditorProps {
  style?: React.CSSProperties;

  onClickBtn?(): void;
}

function FResourceCartoonEditor({ style, onClickBtn }: FResourceCartoonEditorProps) {
  return (
    <div className={styles.cartoonEditor} style={style}>
      <img src={img_markdown} alt={''} style={{ width: 190, height: 20 }} />
      <div style={{ height: 40 }} />
      <FComponentsLib.FContentText
        text={
          // 'Online Comic Formatter'
          FI18n.i18nNext.tAuto('submitresource_tool_comicsformatter_title')
        }
        type={'highlight'}
      />
      <div style={{ height: 10 }} />
      <FComponentsLib.FContentText
        text={
          // '在线上传、排版、一键切图，快速发布漫画'
          FI18n.i18nNext.tAuto('submitresource_tool_comicsformatter_subtittle')
        }
        type={'additional2'}
      />
      <div style={{ height: 40 }} />
      <FComponentsLib.FRectBtn
        type={'primary'}
        onClick={() => {
          onClickBtn && onClickBtn();
        }}
      >
        {
          // 立即体验
          FI18n.i18nNext.tAuto('submitresource_tool_comicsformatter_btn')
        }
      </FComponentsLib.FRectBtn>
    </div>
  );
}

export default FResourceCartoonEditor;
